import React, { Fragment } from "react";
import DataTable from "react-data-table-component";
import "react-toastify/dist/ReactToastify.css";
import DataTableExtensions from "react-data-table-component-extensions";
import placeholder from "../../assets/images/fashion/product/12.jpg";
import moment from "moment";
const Sellitems = ({ myData, myClass }) => {
  const columnDefs = [
    {
      name: "Product Image",
      cell: (row) => (
        <ItemsImage
          image={row.productId ? row?.productId?.bannerImage : placeholder}
        />
      ),
    },
    {
      name: "Product Name",
      selector: (row) => row?.productName,
      sortable: true,
    },
    {
      name: "Product Price",
      selector: (row) => `€ ${row?.price}`,
      sortable: true,
    },
    {
      name: "Quantity",
      selector: (row) => row?.quantity,
      sortable: true,
    },
    {
      name: "Date/Time",
      selector: (row) => moment(row.createdAt).format("DD/MM/YYYY HH:mm"),
      sortable: true,
    },
  ];
  return (
    <div>
      <Fragment>
        <DataTableExtensions
          columns={columnDefs}
          data={myData}
          print={false}
          export={false}>
          <DataTable
            data={myData}
            columns={columnDefs}
            className={myClass}
            pagination
            striped={true}
            center={true}
          />
        </DataTableExtensions>
      </Fragment>
    </div>
  );
};
const ItemsImage = ({ image }) => {
  return (
    <div className="profile-image">
      <img src={image} alt="logo" />
    </div>
  );
};
export default Sellitems;
